import React, { useEffect, useState } from "react";
import { pnpLogo } from "../../../Asserts";
import useDeviceType from "../../../Utiles/FindDevice";
import OtpWithTimer from "../OtpTimer/OtpTimer";
import { useLocation, useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import axios from "axios";
import { toast } from "react-toastify";
import { baseURL } from "../../../services/axiosConfig";
import Button from "../../../Components/Auth/Button";
import { FooterTab, MobileFooter } from "../../../../Components/GreenHome/Footer";
import { initialToken } from "../../RoundToJoin/tocken.slice";

const EmailVerification = () => {
  const deviceType = useDeviceType();
  const [otp, setOtp] = useState("");
  const [resendActive, setResendActive] = useState(false);
  const [isResending, setIsResending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const location = useLocation();
  const userEmail = location.pathname.split("/").pop();
  const fromScreen = location.state?.from;

  const RESEND_TIMEOUT = 20000;
  const [timeLeft, setTimeLeft] = useState(RESEND_TIMEOUT);

  useEffect(() => {
    setResendActive(false);
    const timer = setInterval(() => {
      setTimeLeft(prevTime => {
        if (prevTime <= 1000) {
          clearInterval(timer);
          setResendActive(true);
          return 0;
        }
        return prevTime - 1000;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const handleResend = async () => {
    if (!resendActive || isResending) return;
    try {
      setIsResending(true);
      setOtp("");
      setResendActive(false);
      setTimeLeft(RESEND_TIMEOUT);

      const res = await axios.post(`${baseURL}/accounts/resendotp`, { email: userEmail });

      if (res?.data?.status === "Success") {
        toast.success("OTP resent successfully");
        const timer = setInterval(() => {
          setTimeLeft(prevTime => {
            if (prevTime <= 1000) {
              clearInterval(timer);
              setResendActive(true);
              return 0;
            }
            return prevTime - 1000;
          });
        }, 1000);
      } else {
        toast.error(res?.data?.message || "Failed to resend OTP");
        setResendActive(true);
      }
    } catch (error) {
      console.error("Error resending OTP:", error);
      toast.error("An error occurred while resending OTP");
      setResendActive(true);
    } finally {
      setIsResending(false);
    }
  };

  const formatTime = (ms) => {
    const totalSeconds = Math.floor(ms / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return {
      minutes,
      seconds,
      completed: totalSeconds <= 0
    };
  };

  const handleVerifyCode = async () => {
    setIsLoading(true);
    try {
      if (!otp || otp.length !== 4) {
        toast.error("Please enter a valid 4-digit OTP");
        return;
      }

      const values = {
        otp: otp,
        email: userEmail,
      }

      const res = await axios.post(`${baseURL}/accounts/verifyotp`, values);

      if (res?.data?.error === "User does not exist") {
        console.error("Error verifying OTP:", res.data.error);
        toast.error("User does not exist")
        return;
      }

      if (res?.data?.status === "Success") {
        toast.success("OTP verified successfully");

        if (fromScreen === "forgotPassword") {
          localStorage.setItem("userEmail", userEmail);
          localStorage.setItem("token", res?.data?.data?.token);

          navigate(`/resetPassword/${userEmail}`, { state: { from: "forgotPassword" } })
        } else {
          const pendingEmail =
            sessionStorage.getItem("pendingSignupEmail") ||
            userEmail?.trim()?.toLowerCase();
          const pendingPassword = sessionStorage.getItem("pendingSignupPassword");

          let accessToken;
          let refreshToken;
          let isAdminUser = false;
          let username = "";
          let userUuid = null;

          if (pendingEmail && pendingPassword) {
            try {
              const loginRes = await axios.post(`${baseURL}/accounts/token/`, {
                email: pendingEmail,
                password: pendingPassword,
                timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
              });

              accessToken = loginRes?.data?.access;
              refreshToken = loginRes?.data?.refresh;
              isAdminUser = Boolean(loginRes?.data?.isAdmin);
              username = loginRes?.data?.username || "";
              userUuid = loginRes?.data?.user_uuid || null;
            } catch (loginError) {
              accessToken = null;
            }
          }

          if (!accessToken) {
            const verificationData = res?.data?.data || {};
            accessToken =
              verificationData.access ||
              res?.data?.access ||
              verificationData.token ||
              res?.data?.token;
            refreshToken = verificationData.refresh || res?.data?.refresh;
            isAdminUser = Boolean(verificationData.isAdmin);
          }

          if (!accessToken) {
            toast.error("Please login to continue.");
            navigate("/login", { replace: true });
            return;
          }

          localStorage.setItem("access_token", JSON.stringify(accessToken));
          localStorage.setItem("token", JSON.stringify(accessToken));
          if (refreshToken) {
            localStorage.setItem("refresh", JSON.stringify(refreshToken));
          }
          localStorage.setItem("isAuthUser", "true");
          localStorage.setItem("isAdminUser", isAdminUser);
          localStorage.removeItem("registerEmail");
          localStorage.removeItem("countdownEndTime");
          sessionStorage.removeItem("pendingSignupEmail");
          sessionStorage.removeItem("pendingSignupPassword");

          const baseUserInfo = {
            email: pendingEmail || userEmail,
            isAdmin: isAdminUser,
            userName: username,
            userId: userUuid,
            userLogedIn: true,
          };

          try {
            const profileRes = await axios.get(`${baseURL}/accounts/user/me`, {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            });

            dispatch(initialToken(profileRes?.data?.available_tokens));

            const userInfo = {
              email: profileRes?.data?.email || baseUserInfo.email,
              isAdmin: Boolean(profileRes?.data?.isAdmin),
              userName: profileRes?.data?.username || baseUserInfo.userName || "",
              userId: profileRes?.data?.user_uuid || baseUserInfo.userId,
              userLogedIn: true,
            };
            localStorage.setItem("userInfo", JSON.stringify(userInfo));
            localStorage.setItem("isAdminUser", userInfo.isAdmin);
          } catch (profileError) {
            localStorage.setItem("userInfo", JSON.stringify(baseUserInfo));
          }

          navigate("/dashboard", { replace: true });
        }

      } else {
        toast.error(res?.data?.message || "Invalid OTP. Please try again.");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error?.response?.data);
      toast.error(error?.response?.data?.data?.message || error?.response?.data[0] || "An error occurred while verifying OTP");
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <div
      style={{
        backgroundImage: `url('/v2/images/bg/${
          deviceType === "mobile" ? "auth-bg-mobile.png" : "auth-bg.png"
        }')`,
      }}
      className="bg-cover bg-no-repeat bg-center min-h-screen overflow-hidden flex flex-col justify-between"
    >
      <div
        className={`flex ${
          deviceType === "mobile"
            ? "flex-col py-16"
            : "lg:flex-row justify-between px-24 py-[50px] lg:py-[35px] 2xl:py-[50px]"
        } bg-cover bg-no-repeat bg-center items-start`}
      >
        {deviceType !== "mobile" && (
          <div className={`text-white`}>
            <a href="/"><img src={pnpLogo} alt="Logo" className="h-28 lg:h-44 mb-4 md:-my-6 lg:my-4" /></a>
          </div>
        )}

        <div
          className={`flex flex-col ${
            deviceType === "mobile" ? "w-full px-6" : "h-full lg:mt-12 lg:mx-24"
          } items-center justify-center`}
        >
          {deviceType === "mobile" && (
            <img src={pnpLogo} alt="Logo" className="h-32 w-auto mb-4" />
          )}
          <div
            className={`bg-white rounded-b-[12px] rounded-t-[8px] ${
              deviceType === "mobile"
                ? "w-[100%] mx-auto my-8"
                : deviceType === "tablet"
                ? "w-[350px] max-w-[550px] md:h-96"
                : deviceType === "laptop"
                ? "w-[400px] max-w-[500px] h-96"
                : "w-[400px] max-w-[420px]  h-full"
            }`}
          >
            <div
              className={`bg-gradient-to-r h-[6px] p-1 rounded-tl-[12px] rounded-tr-[12px] from-[#00C05B] to-[#007FFF] w-full`}
            ></div>
            <div className="h-full flex items-center justify-center">
              <div
                className={`${
                  deviceType === "mobile"
                    ? "px-6 py-8"
                    : deviceType === "tablet"
                    ? "px-10 py-12"
                    : "px-10 py-4"
                } flex flex-col align-middle w-full`}
              >
                <div className={deviceType === "mobile" ? "mb-4 mx-auto" : "mb-6"}>
                  <h2
                    className={`font-bold font-archivo text-[#0081F8] ${
                      deviceType === "mobile" ? "text-lg mb-2" : "text-xl lg:text-[22px] mb-3"
                    }`}
                  >
                    {fromScreen === "forgotPassword" ? 'Enter Code' : 'Verify Your Email'}
                  </h2>
                  <p className={`text-black/60 ${
                    deviceType === "mobile"
                      ? "text-sm leading-relaxed mb-1"
                      : "lg:text-[16px] mb-2"
                  }`}>
                    Please enter the code that we sent to <span className={`text-[#0081F8] whitespace-nowrap ${
                    deviceType === "mobile" ? "text-sm" : "text-sm"
                  }`}>{userEmail}</span>
                  </p>
                </div>
                <div className={`${deviceType === "mobile" ? "mb-4" : "mb-6"} w-full`}>
                  <div className="flex justify-start">
                    <OtpWithTimer otp={otp} setOtp={setOtp} />
                  </div>
                </div>

                <div
                  className={`flex items-center ${
                    deviceType === "mobile"
                      ? "mb-4 justify-start w-full"
                      : "mb-6 justify-start w-full"
                  }`}
                >
                  <Button
                    type="button"
                    text="Verify Code"
                    onClick={handleVerifyCode}
                    disabled={isLoading}
                    loading={isLoading}
                    data-testid="verify-code-button"
                  />
                </div>

                <div className="mt-4 text-[14px]">
                  Didn't receive code? Check your spam
                  <p>
                    <button
                      className={`text-[#007FFF] underline ${!resendActive ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer hover:text-[#0056b3]'}`}
                      onClick={handleResend}
                      disabled={!resendActive || isResending}
                    >
                      {isResending ? "Resending..." : "Resend code"}
                    </button>
                    {!resendActive && (
                      <span className="ml-1">
                        in{" "}
                        <span className="text-gray-600">
                          {formatTime(timeLeft).minutes}:{formatTime(timeLeft).seconds < 10 ? `0${formatTime(timeLeft).seconds}` : formatTime(timeLeft).seconds} seconds
                        </span>
                      </span>
                    )}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {deviceType === "mobile" ?
           <MobileFooter /> :
            <FooterTab component="privacyPolicy" className="mt-auto" />
           }
    </div>
  );
};

export default EmailVerification;
